import {createApp} from "vue";
import "animate.css";
import ArcoVue from "@arco-design/web-vue";
import ArcoVueIcon from "@arco-design/web-vue/es/icon";
import App from "./App.vue";
import "@arco-design/web-vue/dist/arco.css";
import "@/assets/fonts/PingFang_Regular.ttf";
import router from "./router";
import store from "./store";
import i18n from './lang'
import util from './common/util';
import logger from './common/util/logger';
// 全局加载KLineChartPro语言包
// KLineChartPro已内置zh-CN和en-US语言包，无需手动导入loadLocales

// 在应用启动时预加载K线图语言包
// 根据当前语言设置加载对应的语言包
const currentLang = util.getCache('lang') || 'en-US';
const klineLocaleMap = {
    'en-US': 'en-US',
    'zh_CN': 'zh-CN',
    'zh_Hant': 'zh-CN',
    'ru': 'en-US',
    'th': 'en-US',
    'ja': 'en-US',
    'ko': 'en-US',
    'au': 'en-US',
    'gm': 'en-US',
    'fr': 'en-US',
    'es': 'en-US',
    'vi': 'en-US'
};
const klineLocale = klineLocaleMap[currentLang] || 'en-US';

// KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
// 只需在创建图表时设置locale参数即可
logger.debug('🔧 全局K线图语言设置:', klineLocale);

import "@/styles/index.scss"
import "@/styles/theme.scss"

// Import Swiper styles
import 'swiper/css';
import "swiper/css/bundle"

// Chrome reports this browser scheduling diagnostic as a window error. It is
// not an application exception and otherwise trips the webpack dev overlay.
if (process.env.NODE_ENV === 'development') {
    window.addEventListener('error', (event) => {
        const message = event?.message || event?.error?.message || '';
        if (/^ResizeObserver loop (completed with undelivered notifications|limit exceeded)\.?$/.test(message)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);
}

const app = createApp(App);

// 全局处理未捕获的Promise rejection
window.addEventListener('unhandledrejection', function(event) {
  logger.error('🛡️ 全局捕获未处理的Promise rejection:', event.reason?.message);
  
  // 对于网络错误，进行友好处理
  if (event.reason?.message?.includes('网络连接失败') || 
      event.reason?.message?.includes('API错误')) {
    logger.warn('🌐 网络相关错误，已记录但不显示为运行时错误');
    event.preventDefault();
    return;
  }
  
  // 其他错误正常处理
  logger.error('❌ 未处理的Promise rejection:', event.reason);
});

app.config.globalProperties.$util = util
app.config.globalProperties.$router = router

// 初始化应用
app.use(ArcoVue)
    .use(ArcoVueIcon)
    .use(store)
    .use(router)
    .use(i18n)
    .mount("#app");
  
